import React from 'react';
import Box from '@material-ui/core/Box';
import {withStyles} from '@material-ui/core';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

const CardSkeleton = withStyles<string, undefined, SkeletonProps>(theme => ({
    root: {
        width: `100%`,
        height: `53px`,

        margin: theme.spacing(0, 0, 0.2, 0),
        borderRadius: theme.shape.borderRadius
    }
}))(props => <Skeleton variant="rect" {...props} />);

const list = Array.from(Array(10).keys());

const MyTop10GamesPanelSkeleton = () => (
    <Box>
        {list.map(listItem => (
            <CardSkeleton key={listItem} />
        ))}
    </Box>
);

export default MyTop10GamesPanelSkeleton;
